/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ValidationDto } from '../../models/validation-dto';

export interface QuestionnaireCheckActiveQuestionnaire$Plain$Params {
  InsurerQuestionnaireId?: number;
}

export function questionnaireCheckActiveQuestionnaire$Plain(http: HttpClient, rootUrl: string, params?: QuestionnaireCheckActiveQuestionnaire$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ValidationDto>> {
  const rb = new RequestBuilder(rootUrl, questionnaireCheckActiveQuestionnaire$Plain.PATH, 'get');
  if (params) {
    rb.query('InsurerQuestionnaireId', params.InsurerQuestionnaireId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ValidationDto>;
    })
  );
}

questionnaireCheckActiveQuestionnaire$Plain.PATH = '/v1/Questionnaire/CheckActiveQuestionnaire';
